import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=21c50482"
import script from "./star-rating.vue?vue&type=script&lang=js"
export * from "./star-rating.vue?vue&type=script&lang=js"
import style0 from "./star-rating.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports